import script from "./ProfileAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileAddress.vue?vue&type=script&setup=true&lang=js"

import "./ProfileAddress.vue?vue&type=style&index=0&id=5ce0ab91&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce0ab91"]])

export default __exports__